// extracted by mini-css-extract-plugin
var _1 = "CalendarSettingsForm-moduleCalendarSettingsForm__WA4lF";
export { _1 as "CalendarSettingsForm" }
